import { render, staticRenderFns } from "./FileDragIcon.vue?vue&type=template&id=401b0291"
import script from "./FileDragIcon.vue?vue&type=script&lang=js"
export * from "./FileDragIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports